/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";

import { useOnFirstRender } from "@web-monorepo/hooks";
import { useParams } from "react-router-dom";
import GroupsRemoteContainer from "src/pods/groups/components/GroupsRemoteContainer";
import DirectionsRemoteContainer from "src/pods/list/components/DirectionsRemoteContainer";
import NoiseRemoteContainer from "src/pods/noise/components/NoiseRemoteContainer";
import PairShareContainer from "src/pods/pairshare/components/sender/PairShareContainer";
import RadioRemoteContainer from "src/pods/radio/components/RadioRemoteContainer";
import RandomRemoteContainer from "src/pods/random/components/RandomRemoteContainer";
import TimerRemoteContainer from "src/pods/timer/components/TimerRemoteContainer";
import TodaySetupContainer from "src/pods/today/components/sender/TodaySetupContainer";
import { metrics } from "src/utils/metrics";

// All remote containers consume classId, mountPoint, and app via this prop shape.
// TodaySetupContainer additionally declares onEdit/payload but doesn't receive them here —
// that's a pre-existing gap, not introduced by this change.
type RemoteParams = { classId: string; mountPoint: string; app: string };
type RemoteContainer = React.ComponentType<{ params: RemoteParams }>;

export default function ToolkitAppRemote() {
  const params = useParams() as Readonly<RemoteParams>;
  let Component: RemoteContainer;
  if (params.app === "pairshare") {
    Component = PairShareContainer;
  } else if (params.app === "today") {
    // TodaySetupContainer declares extra required props (onEdit, payload) that aren't passed here.
    Component = TodaySetupContainer as unknown as RemoteContainer;
  } else if (params.app === "list") {
    Component = DirectionsRemoteContainer;
  } else if (params.app === "timer") {
    Component = TimerRemoteContainer;
  } else if (params.app === "radio") {
    Component = RadioRemoteContainer;
  } else if (params.app === "noise") {
    Component = NoiseRemoteContainer;
  } else if (params.app === "random") {
    Component = RandomRemoteContainer;
  } else if (params.app === "groups") {
    Component = GroupsRemoteContainer;
  } else {
    throw new Error(`Invalid app: ${params.app}`);
  }

  useOnFirstRender(() => {
    metrics.increment(`remote.${params.app}.open`);
  });

  return <Component params={params} />;
}
